module.exports = __webpack_public_path__ + "static/web-recycled-stolen-information-9271dec137aefbac8a31972da3d9eb72.gif";